export default __webpack_public_path__ + "static/media/individual.807d1598.svg";